<template>
  <div id="contenedor-main-contrato-responsables">
    <tool-bar
      class="my-3"
      v-on:registrarResponsable="mostrarVentanaRegistarResponsable = true"
    />
    <listado />
    <v-dialog v-model="mostrarVentanaRegistarResponsable" width="500">
      <registrar-nuevo-responsable
        :idContrato="this.idContrato"
        v-on:cerrar="cerrarVentana"
      />
    </v-dialog>
    <v-dialog
      v-if="esteResponsableContrato"
      v-model="mostrarVentanaEliminarResponsableContrato"
      width="450"
    >
      <eliminar-responsable
        :responsableContratoEliminar="this.esteResponsableContrato"
        v-on:cerrar="cerrarVentana"
      />
    </v-dialog>
  </div>
</template>

<script>
// import CONTRATOS from '@/graphql/querys/administracion/contratos/contratos.gql';
import RegistrarNuevoResponsable from '@/components/administracion/contratos/contrato/responsable/Nuevo.vue';
import EliminarResponsable from '@/components/administracion/contratos/contrato/responsable/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainContratoResponsables',
  components: {
    ToolBar,
    Listado,
    RegistrarNuevoResponsable,
    EliminarResponsable,
  },
  // apollo: {
  //   contratos: {
  //     query: CONTRATOS,
  //   },
  // },
  data() {
    return {
      mostrarVentanaRegistarResponsable: false,
      mostrarVentanaEliminarResponsableContrato: false,
      esteResponsableContrato: null,
      idContrato: this.$route.params.idContrato,
    };
  },
  methods: {
    cerrarVentana() {
      this.mostrarVentanaRegistarResponsable = false;
      this.mostrarVentanaEliminarResponsableContrato = false;
      this.esteResponsableContrato = null;
    },
  },
  computed: {
    // contrato() {
    //   if (!this.contratos) return {};
    //   return this.contratos.find((elem) => elem.id === this.$route.params.idContrato);
    // },
  },
  mounted() {
    eventBus.$on('borrar-responsable-contrato', (responsableContrato) => {
      this.esteResponsableContrato = responsableContrato;
      this.mostrarVentanaEliminarResponsableContrato = true;
    });
  },
};
</script>

<style lang="scss">
</style>
